import './index.less';
import { SvgIcon } from '@/components';
import { BackTop } from '../common';
import { ReactNode, useRef } from 'react';
import classNames from 'classnames';
import Tooltip from 'rc-tooltip';
import miuiWxImg from '@/assets/img/miui-wx.png';
import ArgtModal, { AgreeEnum, getArgtStorage } from '@/pages/Home/AgrtModal';
interface FooterNavItem {
  label: string;
  children: {
    label: string;
    url?: string;
    type?: 'link' | 'hover';
    icon?: string;
    hoverNode?: ReactNode;
  }[];
}

interface FooterProps {
  miniMode?: boolean;
}

export function Footer({ miniMode = false }: FooterProps) {
  const navList: FooterNavItem[] = [
    {
      label: window.trans('relative-link'),
      children: [
        {
          label: window.trans('mi-open-platform'),
          url: 'https://dev.mi.com/console/',
        },
      ],
    },
    {
      label: window.trans('support'),
      children: [
        {
          label: window.trans('doc-center'),
          url: 'https://dev.mi.com/console/doc/',
        },
        {
          label: window.trans('how-developer'),
          url: 'https://dev.mi.com/console/doc/detail?pId=848',
        },
      ],
    },
    {
      label: window.trans('contact-us'),
      children: [
        {
          label: 'overseas-widget@xiaomi.com',
          url: 'mailto:overseas-widget@xiaomi.com',
        },
      ],
    },
    // {
    //   label: '关注我们',
    //   children: [
    //     {
    //       icon: 'weixin',
    //       label: '微信公众号',
    //       type: 'hover',
    //       hoverNode: (
    //         <img
    //           src={miuiWxImg}
    //           alt=""
    //           style={{ width: '80px', margin: '10px' }}
    //         />
    //       ),
    //     },
    //   ],
    // },
  ];
  const elRef = useRef<HTMLElement>(null);
  return (
    <footer ref={elRef} className="main-content-wrapper mag-footer-wrapper">
      <div className="main-content mag-footer">
        {!miniMode && (
          <ul className="mag-footer-nav">
            {navList.map((item, index) => (
              <li key={index} className="mag-footer-nav-item">
                <span>{item.label}</span>
                <ul>
                  {item.children.map((subItem, subIndex) => {
                    let node = (
                      <>
                        {subItem.icon && <SvgIcon name={subItem.icon} />}
                        {(!subItem.type || subItem.type === 'link') && (
                          <a
                            href={subItem.url}
                            target="_blank"
                            rel="noreferrer"
                            onClick={(e) => {
                              if (getArgtStorage() === AgreeEnum.NO) {
                                ArgtModal.show();
                                e.preventDefault();
                              }
                            }}
                          >
                            {subItem.label}
                          </a>
                        )}
                        {subItem.type && subItem.type !== 'link' && (
                          <span>{subItem.label}</span>
                        )}
                      </>
                    );
                    if (subItem.type === 'hover') {
                      node = (
                        <Tooltip placement="top" overlay={subItem.hoverNode}>
                          <span>{node}</span>
                        </Tooltip>
                      );
                    }
                    return (
                      <li
                        key={`${index}-${subIndex}`}
                        className="mag-footer-nav-sub-item"
                      >
                        {node}
                      </li>
                    );
                  })}
                </ul>
              </li>
            ))}
          </ul>
        )}
        <div className={classNames('mag-footer-copyright', { mini: miniMode })}>
          <span className="brand flex-center">
            <SvgIcon name="logo" />
            <span>{window.trans('widget')}</span>
          </span>
          <span className="cr">{ window.trans('copyright') }</span>
          <span className="cr">
            <a
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802020134"
              target="_blank"
              rel="noreferrer"
            >
              { window.trans('xiaomi') }
            </a>
          </span>
        </div>
      </div>
      {!miniMode && (
        <BackTop stickyBottomTarget={elRef} stickyBottomMargin={64} />
      )}
    </footer>
  );
}
